const isLocal = false;
export const URLs = {
  domain: isLocal ? "http://localhost:5000" : "https://dev.chefp.in",
  images: isLocal
    ? "http://localhost:5000/uploads/"
    : "https://dev.chefp.in/uploads/",
};
